"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBusinessInvitationRequestToJSON = exports.CreateBusinessInvitationRequestFromJSONTyped = exports.CreateBusinessInvitationRequestFromJSON = exports.instanceOfCreateBusinessInvitationRequest = void 0;
var BusinessRole_1 = require("./BusinessRole");
/**
 * Check if a given object implements the CreateBusinessInvitationRequest interface.
 */
function instanceOfCreateBusinessInvitationRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "emailAddress" in value;
    isInstance = isInstance && "businessRole" in value;
    return isInstance;
}
exports.instanceOfCreateBusinessInvitationRequest = instanceOfCreateBusinessInvitationRequest;
function CreateBusinessInvitationRequestFromJSON(json) {
    return CreateBusinessInvitationRequestFromJSONTyped(json, false);
}
exports.CreateBusinessInvitationRequestFromJSON = CreateBusinessInvitationRequestFromJSON;
function CreateBusinessInvitationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'emailAddress': json['email_address'],
        'businessRole': (0, BusinessRole_1.BusinessRoleFromJSON)(json['business_role']),
    };
}
exports.CreateBusinessInvitationRequestFromJSONTyped = CreateBusinessInvitationRequestFromJSONTyped;
function CreateBusinessInvitationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email_address': value.emailAddress,
        'business_role': (0, BusinessRole_1.BusinessRoleToJSON)(value.businessRole),
    };
}
exports.CreateBusinessInvitationRequestToJSON = CreateBusinessInvitationRequestToJSON;
